import React from "react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import {
  getDocDataSnap,
  setDocData,
} from "../../../utils/firebase/Firebase.utils";
import { useParams } from "react-router-dom";
import Modal from "../Components/Modal";
import { useSelector } from "react-redux";
import { useCompany } from "../../../context/CompanyContext";
import ResidentForm from "./ResidentForm";

export default function ResidentInformationPage({}) {
  const { companyData } = useCompany();
  const { id } = useParams();
  const [formData, setFormData] = React.useState({});
  const [editMode, setEditMode] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [resident, setResident] = React.useState({});

  const currentUser = useSelector((state) => state.userObject);

  const allowableAccess = ["admin", "maker", "approver"];
  const userRoles = currentUser.roles;

  const { terms } = useCompany();

  useEffect(() => {
    const fetchResidents = async () => {
      await getDocDataSnap("residents", id, (data) => {
        setResident(data);
        setFormData(data);
        setIsLoading(false);
      });
    };
    fetchResidents();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-eleghoBlue"></div>
      </div>
    );
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditMode = () => {
    setEditMode(!editMode);
    if (editMode) {
      setFormData(resident);
      toast.error("Changes have not been saved");
    }
  };

  const handleSave = async (e) => {
    if (window.confirm("Are you sure you want to save the changes?")) {
      e.preventDefault();
      setIsProcessing(true);

      let identifier;
      if (companyData && companyData.entityType === "hoa") {
        identifier = formData.streetName
          ? `Unit ${formData.lot} - ${formData.streetName}`
          : `Unit ${formData.lot} - Tower ${formData.phase}`;
      } else {
        identifier = `Unit ${formData.lot} - Tower ${formData.phase}`;
      }

      const docObject = {
        ...formData,
        identifier,
      };

      await setDocData("residents", id, docObject);
      toast.success("Changes saved successfully");
      setEditMode(false);
      setIsProcessing(false);
    }
  };

  return (
    <>
      <ResidentForm
        resident={resident}
        formData={formData}
        editMode={editMode}
        isProcessing={isProcessing}
        handleChange={handleChange}
        handleEditMode={handleEditMode}
        handleSave={handleSave}
        allowableAccess={allowableAccess}
        userRoles={userRoles}
        terms={terms}
        companyData={companyData}
      />

      {/* Processing Modal */}
      {isProcessing && (
        <Modal>
          <div className="flex items-center gap-2">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-eleghoBlue"></div>
            <span className="text-sm font-medium text-gray-900">
              Saving changes...
            </span>
          </div>
        </Modal>
      )}
    </>
  );
}
